import { apiFetch } from "./client";

import type {
  PurchaseInitiateReq,
  PurchaseInitiateResp,
  PurchaseConfirmReq,
  PurchaseConfirmResp,
} from "@zrt-ai-office/types";

/** 发起支付 — POST /skill/api/v1/purchase/initiate */
export function initiatePurchase(
  req: PurchaseInitiateReq,
): Promise<PurchaseInitiateResp> {
  return apiFetch<PurchaseInitiateResp>("/skill/api/v1/purchase/initiate", {
    method: "POST",
    body: req,
  });
}

/** 确认支付 — POST /skill/api/v1/purchase/confirm */
export function confirmPurchase(
  req: PurchaseConfirmReq,
): Promise<PurchaseConfirmResp> {
  return apiFetch<PurchaseConfirmResp>("/skill/api/v1/purchase/confirm", {
    method: "POST",
    body: req,
  });
}
